__turbopack_context__.v({
  "activeBtn": "artikel-module__cT_NFW__activeBtn",
  "arrow": "artikel-module__cT_NFW__arrow",
  "articleContainer": "artikel-module__cT_NFW__articleContainer",
  "articleContent": "artikel-module__cT_NFW__articleContent",
  "articleDate": "artikel-module__cT_NFW__articleDate",
  "articleDetail": "artikel-module__cT_NFW__articleDetail",
  "articleExcerpt": "artikel-module__cT_NFW__articleExcerpt",
  "articleFooter": "artikel-module__cT_NFW__articleFooter",
  "articleImageBlock": "artikel-module__cT_NFW__articleImageBlock",
  "articleMeta": "artikel-module__cT_NFW__articleMeta",
  "articleTitle": "artikel-module__cT_NFW__articleTitle",
  "articlesSection": "artikel-module__cT_NFW__articlesSection",
  "backLink": "artikel-module__cT_NFW__backLink",
  "breadcrumb": "artikel-module__cT_NFW__breadcrumb",
  "breadcrumbCurrent": "artikel-module__cT_NFW__breadcrumbCurrent",
  "breadcrumbLink": "artikel-module__cT_NFW__breadcrumbLink",
  "breadcrumbSeparator": "artikel-module__cT_NFW__breadcrumbSeparator",
  "card": "artikel-module__cT_NFW__card",
  "cardBody": "artikel-module__cT_NFW__cardBody",
  "cardExcerptModern": "artikel-module__cT_NFW__cardExcerptModern",
  "cardImage": "artikel-module__cT_NFW__cardImage",
  "cardMeta": "artikel-module__cT_NFW__cardMeta",
  "cardTitleModern": "artikel-module__cT_NFW__cardTitleModern",
  "clearSearch": "artikel-module__cT_NFW__clearSearch",
  "date": "artikel-module__cT_NFW__date",
  "dateSmall": "artikel-module__cT_NFW__dateSmall",
  "detailHeader": "artikel-module__cT_NFW__detailHeader",
  "emptyState": "artikel-module__cT_NFW__emptyState",
  "featuredBadge": "artikel-module__cT_NFW__featuredBadge",
  "featuredCard": "artikel-module__cT_NFW__featuredCard",
  "featuredContent": "artikel-module__cT_NFW__featuredContent",
  "featuredExcerpt": "artikel-module__cT_NFW__featuredExcerpt",
  "featuredImage": "artikel-module__cT_NFW__featuredImage",
  "featuredSection": "artikel-module__cT_NFW__featuredSection",
  "featuredTitle": "artikel-module__cT_NFW__featuredTitle",
  "grid": "artikel-module__cT_NFW__grid",
  "heroImage": "artikel-module__cT_NFW__heroImage",
  "heroImageFallback": "artikel-module__cT_NFW__heroImageFallback",
  "logoFallbackFeatured": "artikel-module__cT_NFW__logoFallbackFeatured",
  "logoFallbackSmall": "artikel-module__cT_NFW__logoFallbackSmall",
  "main": "artikel-module__cT_NFW__main",
  "pageBtn": "artikel-module__cT_NFW__pageBtn",
  "pageDots": "artikel-module__cT_NFW__pageDots",
  "pagination": "artikel-module__cT_NFW__pagination",
  "placeholder": "artikel-module__cT_NFW__placeholder",
  "readMoreModern": "artikel-module__cT_NFW__readMoreModern",
  "readMoreSmall": "artikel-module__cT_NFW__readMoreSmall",
  "relatedSection": "artikel-module__cT_NFW__relatedSection",
  "relatedTitle": "artikel-module__cT_NFW__relatedTitle",
  "searchButton": "artikel-module__cT_NFW__searchButton",
  "searchClear": "artikel-module__cT_NFW__searchClear",
  "searchForm": "artikel-module__cT_NFW__searchForm",
  "searchIcon": "artikel-module__cT_NFW__searchIcon",
  "searchInput": "artikel-module__cT_NFW__searchInput",
  "searchInputWrapper": "artikel-module__cT_NFW__searchInputWrapper",
  "searchResultsHeader": "artikel-module__cT_NFW__searchResultsHeader",
  "seoContent": "artikel-module__cT_NFW__seoContent",
  "seoText": "artikel-module__cT_NFW__seoText",
  "shareFacebook": "artikel-module__cT_NFW__shareFacebook",
  "shareLink": "artikel-module__cT_NFW__shareLink",
  "shareLinks": "artikel-module__cT_NFW__shareLinks",
  "shareSection": "artikel-module__cT_NFW__shareSection",
  "shareWhatsApp": "artikel-module__cT_NFW__shareWhatsApp",
  "shimmer": "artikel-module__cT_NFW__shimmer",
  "skeleton": "artikel-module__cT_NFW__skeleton",
  "skeletonFeatured": "artikel-module__cT_NFW__skeletonFeatured",
  "skeletonImage": "artikel-module__cT_NFW__skeletonImage",
  "skeletonText": "artikel-module__cT_NFW__skeletonText",
  "skeletonTitle": "artikel-module__cT_NFW__skeletonTitle",
});
